'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var withStyles = require('../../node_modules/@material-ui/core/styles/withStyles.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var ConfirmationDialog = require('./ConfirmationDialog.js');
var ArrowBack = require('../../node_modules/@material-ui/icons/ArrowBack.js');
var ArrowForward = require('../../node_modules/@material-ui/icons/ArrowForward.js');
var Grid = require('../../node_modules/@material-ui/core/esm/Grid/Grid.js');
var IconButton = require('../../node_modules/@material-ui/core/esm/IconButton/IconButton.js');
var Dialog = require('../../node_modules/@material-ui/core/esm/Dialog/Dialog.js');
var DialogContent = require('../../node_modules/@material-ui/core/esm/DialogContent/DialogContent.js');
var DialogActions = require('../../node_modules/@material-ui/core/esm/DialogActions/DialogActions.js');
var Button = require('../../node_modules/@material-ui/core/esm/Button/Button.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _dec, _class;
var styles = {
  img: {
    maxWidth: '100%',
    maxHeight: '70vh'
  }
};
var PhotoDialog = (_dec = withStyles(styles), _dec(_class =
/*#__PURE__*/
function (_PureComponent) {
  inherits(PhotoDialog, _PureComponent);

  function PhotoDialog(props) {
    var _this;

    classCallCheck(this, PhotoDialog);

    _this = possibleConstructorReturn(this, getPrototypeOf(PhotoDialog).call(this, props));
    _this.state = {
      showConfirmation: false
    };
    return _this;
  }

  createClass(PhotoDialog, [{
    key: "handleDeleteClick",
    value: function handleDeleteClick() {
      this.setState({
        showConfirmation: true
      });
    }
  }, {
    key: "createDialogContent",
    value: function createDialogContent() {
      var _this$props = this.props,
          classes = _this$props.classes,
          focusedImage = _this$props.focusedImage,
          onBackClick = _this$props.onBackClick,
          onForwardClick = _this$props.onForwardClick,
          disableBack = _this$props.disableBack,
          disableForward = _this$props.disableForward;

      if (ObjectHelper.isPresent(focusedImage.original_url)) {
        return React__default["default"].createElement(Grid["default"], {
          container: true,
          alignItems: "center",
          justify: "center"
        }, React__default["default"].createElement(Grid["default"], {
          item: true
        }, React__default["default"].createElement(IconButton["default"], {
          onClick: function onClick() {
            return onBackClick();
          },
          disabled: disableBack
        }, React__default["default"].createElement(ArrowBack, null))), React__default["default"].createElement(Grid["default"], {
          item: true,
          container: true,
          xs: true,
          justify: "center"
        }, React__default["default"].createElement(Grid["default"], {
          item: true
        }, React__default["default"].createElement("img", {
          src: focusedImage.original_url,
          alt: focusedImage.altText,
          className: classes.img
        }))), React__default["default"].createElement(Grid["default"], {
          item: true
        }, React__default["default"].createElement(IconButton["default"], {
          onClick: function onClick() {
            return onForwardClick();
          },
          disabled: disableForward
        }, React__default["default"].createElement(ArrowForward, null))));
      } else return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          open = _this$props2.open,
          focusedImage = _this$props2.focusedImage,
          _onClose = _this$props2.onClose,
          onDelete = _this$props2.onDelete,
          canEdit = _this$props2.canEdit;
      return React__default["default"].createElement(Dialog["default"], {
        fullWidth: true,
        maxWidth: "lg",
        open: open,
        onClose: function onClose() {
          return _onClose();
        }
      }, React__default["default"].createElement(DialogContent["default"], null, this.createDialogContent()), canEdit && React__default["default"].createElement(DialogActions["default"], null, React__default["default"].createElement(Button["default"], {
        color: "secondary",
        onClick: function onClick() {
          return _this2.handleDeleteClick();
        }
      }, "Delete"), React__default["default"].createElement(Button["default"], {
        onClick: function onClick() {
          return _onClose();
        }
      }, "Cancel")), React__default["default"].createElement(ConfirmationDialog, {
        open: this.state.showConfirmation,
        message_title: "Are you sure?",
        message_body: "",
        cancelButtonMessage: "No",
        confirmButtonMessage: "Yes",
        onCancelClick: function onCancelClick() {
          return _this2.setState({
            showConfirmation: false
          });
        },
        onConfirmClick: function onConfirmClick() {
          onDelete(focusedImage);

          _this2.setState({
            showConfirmation: false
          });
        }
      }));
    }
  }]);

  return PhotoDialog;
}(React.PureComponent)) || _class);
PhotoDialog.defaultProps = {
  open: false,
  focusedImage: {},
  canEdit: false
};

module.exports = PhotoDialog;
